(function () {
  'use strict';

  function getConfig() {
    return window.__SKIO_THEME_BRIDGE__ || {};
  }

  function initAndrogenSkioCustomization(config) {
    if (!config.isAndrogenOfferProduct) return;

    var attempts = 0;
    var maxAttempts = 50;
    var timer = setInterval(function () {
      attempts += 1;
      var skioPicker = document.querySelector('skio-plan-picker');

      if (skioPicker && skioPicker.shadowRoot) {
        var prices = skioPicker.shadowRoot.querySelectorAll('.skio-per-day-price');
        var contents = skioPicker.shadowRoot.querySelectorAll('.skio-per-day-content');

        if (prices.length || contents.length) {
          prices.forEach(function (el) {
            el.style.display = 'none';
          });

          contents.forEach(function (el) {
            el.textContent = 'Free Shipping On Orders over $99';
          });

          clearInterval(timer);
          return;
        }
      }

      if (attempts >= maxAttempts) {
        clearInterval(timer);
      }
    }, 200);
  }

  function initSkioCheckoutButton(config) {
    var btn = document.getElementById('skio-checkout-btn');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: config.checkoutVariantId,
              quantity: 1,
              selling_plan: String(config.checkoutSellingPlanId || '')
            }
          ]
        })
      })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (error) {
          console.error(error);

        });
    });
  }

  function initSkioPlanPickerTabs(config) {
    var shadowHost = document.querySelector('skio-plan-picker');
    if (!shadowHost || !shadowHost.shadowRoot) return;

    var sellingPlanInput = shadowHost.parentElement.querySelector('input[name="selling_plan"]');
    if (!sellingPlanInput) return;

    var skioPlanPicker = shadowHost.shadowRoot.querySelector('.skio-plan-picker');
    if (!skioPlanPicker) return;

    var discountInput = skioPlanPicker.querySelector('input[name="properties[Discount]"]');
    var skioOtContainer = shadowHost.shadowRoot.querySelector('[skio-ot-container]');
    var skioSubsContainer = shadowHost.shadowRoot.querySelector('[skio-subs-container]');
    var skioTabCustom1 = shadowHost.shadowRoot.querySelector('#skioTabCustom1');
    var skioTabCustom2 = shadowHost.shadowRoot.querySelector('#skioTabCustom2');

    if (
      !discountInput ||
      !skioOtContainer ||
      !skioSubsContainer ||
      !skioTabCustom1 ||
      !skioTabCustom2
    ) {
      return;
    }

    if (skioSubsContainer.classList.contains('skio-group-container--selected')) {
      skioTabCustom1.classList.add('skio-group-container--selected');
    }

    skioTabCustom1.addEventListener('click', function () {
      handleTabClick(
        skioTabCustom1,
        skioSubsContainer,
        skioOtContainer,
        skioTabCustom2,
        sellingPlanInput,
        discountInput,
        20,
        config.checkoutSellingPlanId
      );
    });

    skioTabCustom2.addEventListener('click', function () {
      handleTabClick(
        skioTabCustom2,
        skioOtContainer,
        skioSubsContainer,
        skioTabCustom1,
        sellingPlanInput,
        discountInput,
        0,
        config.checkoutSellingPlanId
      );
    });
  }

  function handleTabClick(
    clickedTab,
    containerToSelect,
    containerToDeselect,
    otherTab,
    sellingPlanInput,
    discountInput,
    discountValue,
    sellingPlanId
  ) {
    clickedTab.classList.add('skio-group-container--selected');
    otherTab.classList.remove('skio-group-container--selected');

    containerToSelect.classList.add('skio-group-container--selected');
    containerToDeselect.classList.remove('skio-group-container--selected');

    if (discountValue === 20) {
      discountInput.value = '20%';
      discountInput.disabled = false;

      var inputToSelect = containerToSelect.querySelector('input[type="radio"]');
      if (inputToSelect) {
        inputToSelect.setAttribute('checked', ' ');
      }

      sellingPlanInput.value = String(sellingPlanId || '');
    } else if (discountValue === 0) {
      discountInput.value = '0%';
      discountInput.disabled = true;

      var inputToDeselect = containerToDeselect.querySelector('input[type="radio"]');
      if (inputToDeselect) {
        inputToDeselect.removeAttribute('checked');
      }

      sellingPlanInput.value = '';
    }
  }

  function initBoosterSkioBridge() {
    document.addEventListener('booster:variant:select', function (e) {
      var variantId = e.detail && e.detail.selectedVariant && e.detail.selectedVariant.id;
      if (!variantId) return;
      document.dispatchEvent(new CustomEvent('variantChanged', {
        detail: { variantId: variantId }
      }));
    });
  }

  function init() {
    var config = getConfig();
    if (!config.isProductPage) return;

    initBoosterSkioBridge();
    initAndrogenSkioCustomization(config);
    initSkioCheckoutButton(config);
    initSkioPlanPickerTabs(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
